import React from "react";
import { Shimmer } from "components/shimmer";
import classNames from "classnames";
import { usePermissionRules } from "permissions/hooks/usePermissionRules";

export const PermissionControlledInput = ({
  rule = "update:*",
  collection,
  field,
  className,
  children,
  type,
  showWhenDisabled = true,
  isDisabled = false,
  disabledMessage,
  fallback = null,
  showDisabled = false,
}) => {
  const { data: permissions, isLoading } = usePermissionRules(
    [rule],
    collection,
    field
  );
  
  const action = rule.split(":")[0];

  if (isLoading) {
    return <Shimmer className="h-10 " />;
  }

  const hasPermission = permissions?.[action] || false;

  const disabled = !hasPermission || showDisabled || isDisabled;

  if (!showWhenDisabled && disabled) {
    return disabledMessage ? (
      <div className="text-sm text-gray-500 italic">{disabledMessage}</div>
    ) : fallback ? (
      fallback
    ) : null;
  }

  return (
    <div
      className={classNames(
        "w-full",

        {
          "opacity-60 cursor-not-allowed": disabled,
        },
        { "grid gap-2": type === "form" },
        className
      )}
    >
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            disabled: disabled || child.props.disabled,
            "aria-disabled": disabled,
          });
        }
        return child;
      })}
    </div>
  );
};
